import React from 'react';
export function TwinWireSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-3071">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3072">
        Twin Wire EDM Machining
      </h2>
      <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-3073">
        <div className="space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-3074">
          <p data-id="element-3075">
            Until now, the choices available to operators involved in machining
            operations ideally requiring two different wires were limited. They
            performed both roughing and finishing with the same 0.004" diameter
            wire, thus slowing down the manufacturing process. Or they manually
            switched wires - cutting productivity as a result of a tedious
            changeover process. But this is now a thing of the past. Now, new
            wire EDM machines are designed with a fully automated dual-wire
            system, allowing operators the flexibility and versatility that they
            want without the need for manual intervention or changeover.
          </p>
          <p data-id="element-3076">
            Without the need to change wire guides or to perform dual
            pre-settings, operators no longer run the risk of losing precision
            by manually switching wires. Instead, some wire EDM's are now
            capable of choosing for each cavity the optimum solution in terms of
            productivity and work schedule. And since operators now have a
            choice on how to best optimize the performance of their machine,
            they enjoy the kind of flexibility they never had before.
          </p>

          <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 mt-6" data-id="element-3077">
            <h3 className="text-xl font-bold text-navy mb-4 italic" data-id="element-3078">
              Twin Wire EDM Benefits
            </h3>
            <ul className="list-disc list-inside space-y-3 text-base" data-id="element-3079">
              <li data-id="element-3080">
                Automatic wire changeover on one and the same machine for
                flawless roughing and finishing in half the time.
              </li>
              <li data-id="element-3081">
                Just one second to change from one wire diameter to the other
                for a combined threading and changeover time of no more than 45
                seconds - much less than manual intervention or switching to
                another machine.
              </li>
              <li data-id="element-3082">
                Precision remains unaffected by changeover whether operations
                involve roughing or finishing.
              </li>
              <li data-id="element-3083">
                Maximum versatility allows operators to schedule unattended
                machining jobs as they see fit (overnight, weekends).
              </li>
            </ul>
          </div>

          <div className="pt-4" data-id="element-3084">
            <a href="59m7/agiecharmilles-edm/wire-edm/top-end-accuracy.html" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-lg" data-id="element-3085">
              See our Twin Wire Solutions →
            </a>
          </div>
        </div>
        <div data-id="element-3086">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/EDM%20Images/Twin%20Wire.jpeg" alt="Twin Wire" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3087" />
        </div>
      </div>
    </div>;
}